import script from "./bigTab.vue?vue&type=script&setup=true&lang=js"
export * from "./bigTab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__